import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { changeTab } from '../../../Actions/Configurator.action';
import { translate } from '../../../Services/translation';

const ConfiguratorTabs = ({ isLoading }) => {
  const dispatch = useDispatch(),
    selectedTab = useSelector((state) => state.configurator.selectedTab),
    isConfigurable = useSelector((state) => state.configurator.isConfigurable);

  return (
    <>
      {isConfigurable && (
        <div className={'tab-navigator' + (isLoading ? ' tab-navigator--loading' : '')}        >
          <a onClick={() => dispatch(changeTab(1))} className={'tab' + (selectedTab === 1 ? ' tab--active' : '')} >
            {translate('configurator.service.stock')}
          </a>
          <a onClick={() => dispatch(changeTab(2))} className={'tab' + (selectedTab === 2 ? ' tab--active' : '')} >
            {translate('configurator.service.production')}
          </a>
        </div>
      )}
    </>
  );
};

export default ConfiguratorTabs;
